export { default as combineSearches } from './combineSearches';
export { default as normalizeFetchedSuggestions } from './normalizeFetchedSuggestions';
export { default as normalizeSavedSearches } from './normalizeSavedSearches';
export { default as normalizeSuggestionSelection } from './normalizeSuggestionSelection';
